/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Bollard } from './Bollard';
import {
    BollardFromJSON,
    BollardFromJSONTyped,
    BollardToJSON,
} from './Bollard';
import type { LineStringGeometry } from './LineStringGeometry';
import {
    LineStringGeometryFromJSON,
    LineStringGeometryFromJSONTyped,
    LineStringGeometryToJSON,
} from './LineStringGeometry';
import type { PolygonGeometry } from './PolygonGeometry';
import {
    PolygonGeometryFromJSON,
    PolygonGeometryFromJSONTyped,
    PolygonGeometryToJSON,
} from './PolygonGeometry';
import type { QuayData } from './QuayData';
import {
    QuayDataFromJSON,
    QuayDataFromJSONTyped,
    QuayDataToJSON,
} from './QuayData';

/**
 * 
 * @export
 * @interface Quay
 */
export interface Quay {
    /**
     * 
     * @type {number}
     * @memberof Quay
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Quay
     */
    name?: string;
    /**
     * 
     * @type {QuayData}
     * @memberof Quay
     */
    data?: QuayData;
    /**
     * 
     * @type {LineStringGeometry}
     * @memberof Quay
     */
    line?: LineStringGeometry;
    /**
     * 
     * @type {PolygonGeometry}
     * @memberof Quay
     */
    polygon?: PolygonGeometry;
    /**
     * 
     * @type {Array<Bollard>}
     * @memberof Quay
     */
    bollards?: Array<Bollard>;
}

/**
 * Check if a given object implements the Quay interface.
 */
export function instanceOfQuay(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function QuayFromJSON(json: any): Quay {
    return QuayFromJSONTyped(json, false);
}

export function QuayFromJSONTyped(json: any, ignoreDiscriminator: boolean): Quay {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'data': !exists(json, 'data') ? undefined : QuayDataFromJSON(json['data']),
        'line': !exists(json, 'line') ? undefined : LineStringGeometryFromJSON(json['line']),
        'polygon': !exists(json, 'polygon') ? undefined : PolygonGeometryFromJSON(json['polygon']),
        'bollards': !exists(json, 'bollards') ? undefined : ((json['bollards'] as Array<any>).map(BollardFromJSON)),
    };
}

export function QuayToJSON(value?: Quay | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'data': QuayDataToJSON(value.data),
        'line': LineStringGeometryToJSON(value.line),
        'polygon': PolygonGeometryToJSON(value.polygon),
        'bollards': value.bollards === undefined ? undefined : ((value.bollards as Array<any>).map(BollardToJSON)),
    };
}

